/**
 * @flow
 */

import _ from 'lodash';

class GlobalState {

  /**
   * To ensure a Redux-like global state, and facilitate the debug with
   * Redux DevTools, we use a global state.
   * We use the store class name as key, and put the store's state as value.
   */
  globalState = {};

  stores = [];

  /**
   * contains all the defined app events (usually in constants/Events)
   * We use it to force update the old stores that use custom events
   */
  appEvents = [];

  /**
   * static function to retrieve the global state
   * Used to init the React DevTools on DevelopmentUtils for example.
   */
  getGlobalState() {
    return this.globalState;
  }

  setForId(id, state) {
    this.globalState[id] = state;
  }

  getForId(id) {
    return this.globalState[id];
  }

  devToolsListener = (message) => {
    // see https://github.com/zalmoxisus/redux-devtools-extension/blob/master/docs/API/Methods.md
    if (message.type === 'DISPATCH' && message.state) {
      console.log('DevTools requested to change the state');

      const newState = _.cloneDeepWith(this.globalState); // TODO = {};

      const newStateJson = JSON.parse(message.state);
      console.log('newState', newState);
      //
      // Note: disabled because message.state is a json, and our globalState contains object..
      // TODO: find magic way to recreate the state with objects..
      //
      // this.globalState = {};
      //

      // for each store, recreate the objects
      _.each(this.stores, (store) => {
        // no need to try to restore a store that does not handle it.
        if (!_.isFunction(store.getStateObjectsMap)) {
          // TODO: add dev warning.
          return;
        }

        // const storeInitialState = store.getInitialState();

        // TODO: in debug, diff storeInitialState keys and getStateObjectsMap keys in order to
        // find forgetten state keys on getStateObjectsMap.

        // the json that represent the state for this store.
        const storeStateJson = newStateJson[store._id];

        // The store handle `getStateObjectsMap` function.
        if (!_.isUndefined(store.getStateObjectsMap)) {
          // retrieve data to map json to objects
          const mapJsonStateToObjectData = store.getStateObjectsMap();

          // for each key of the state
          for (let k in mapJsonStateToObjectData) {
            const objectJson = storeStateJson[k];
            const classToRecreate = mapJsonStateToObjectData[k];
            console.log('classToRecreate', classToRecreate);

            if (!_.isNil(objectJson)
            && !_.isNil(classToRecreate)
            && _.isFunction(classToRecreate.fromJson)) {
              // the object have a fromJson function, so it's an instance of ApiObject, we recreate
              // the data
              storeStateJson[k] = classToRecreate.fromJson(objectJson);
            } else {
              // TODO: handle arrays of objects.. See ReviewStore usersReviewsSummary
              storeStateJson[k] = objectJson;
            }
          }
        }

        console.log('storeStateJson', storeStateJson);
        newState[store._id] = storeStateJson;
      });

      // update global state
      this.globalState = newState;

      // notify all the stores that the state changed.

      _.each(this.stores, (store) => {
        // no need to try to restore a store that does not handle it.
        if (!_.isFunction(store.getStateObjectsMap)) {
          return;
        }

        if (!store.isEmitingCustomEvents()) {
          store.__onGlobalStateChange();
        } else {
          // Old store.
          // For now we send all the appEvents :/
          _.each(this.appEvents, (event) => {
            if (event.endsWith('SUCCESS')) {
              store.__emitter.emit(event);
            }
          });
        }
      });
    }
  }

  registerStore(store) {
    this.stores.push(store);
  }
}

export default new GlobalState();
